/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowBigRight = [
  "svg",
  defaultAttributes,
  [["path", { d: "M6 9h6V5l7 7-7 7v-4H6V9z" }]]
];

export { ArrowBigRight as default };
//# sourceMappingURL=arrow-big-right.js.map
